import React from 'react';
import classNames from 'classnames';

import styles from './styles.module.scss';

interface IResultHeaderProps {
  isWon: boolean;
  icon: string;
  text: string;
  gameType: string;
}

const ResultHeader: React.FC<IResultHeaderProps> = ({ isWon, icon, text, gameType }) => {
  return (
    <div
      className={classNames(styles.header, styles[gameType], {
        [styles.won]: isWon,
        [styles.lost]: !isWon,
      })}
    >
      <div className={styles.content}>
        <img alt="" src={icon} className={styles.icon} />
        <div className={styles.title}>{text}</div>
      </div>
    </div>
  );
};

export default ResultHeader;
